<template>
    <a-card>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{index + 1}}</template> -->
            <template #enable="{record}">
                <switch-btn :value="record.enable" key-field="enable" :switch-url="editUrl"
                            :checkedValue="0" :uncheckedValue="1"
                            :params="{id: record.id}"
                            @ok="loadData"/>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <a @click="onEdit(record.id)">编辑</a>
                    <a @click="onSetLimit(record.id)">菜单权限</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <LimitModal ref="limitModal"/>
<!--    <CategoryModal1 ref="categoryModal" v-if="show" :roleId="roleId" @onCloseModel="onCloseModel"/>-->
</template>
<script>
import {tableListMixin} from "@/mixins";
import AddOrEditModal from "./components/AddOrEditModal";
import LimitModal from "@/views/sys/role/components/LimitModal";
import {sys_role} from "@/api/adminService";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "角色名称", dataIndex: "name", key: "name"},
    {title: "描述", dataIndex: "describes", key: "describes"},
    {title: "排序值", dataIndex: "sort", key: "sort"},

    {title: "启用状态", dataIndex: "enable", key: "enable", slots: {customRender: "enable"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin],
    components: {
        LimitModal,
        AddOrEditModal,
    },
    data() {
        return {
            columns,
            queryParam: {},
            listUrl: sys_role.getRoleListData,
            listKeyField: "id",
            deleteUrl: sys_role.remove,
            editUrl: sys_role.saveUpdate,
            show:false,
            roleId:''
        }
    },
    methods: {
        onAdd() {
            this.onShowModal("modal");
        },
        onEdit(id) {
            this.getAction({
                url: sys_role.getDetail,
                params: {id: id},
                returnMsg: true
            }).then(res => {
                this.onShowModal("modal", res.data || {});
            })
        },
        async onSetLimit(key) {
            this.$refs['limitModal'].menuList = await this.getAction({
                url: sys_role.getMenuList,
                params: {
                    roleId: key
                }
            });
            this.onShowModal('limitModal', {
                roleId: key,
            })
        },
        onCloseModel() {
            this.show = false
            this.loadData()
        }
    }
}
</script>
<style scoped lang="less">
</style>
